<script setup lang="ts">
import ButtonClose from '@/components/button/ButtonClose.vue'
import {
    alertMessageEmptyHappy,
    alertMessageHappy
} from '@/happyTheme/event/dashboard/alert/AlertMessageHappy'

function toggleAlertMessageHappy() {
    alertMessageHappy.value = alertMessageEmptyHappy
}
</script>

<template>
    <section class="section-alert-message-dashboard-happy">
        <section
            class="alert-message-dashboard-overlay-happy"
            @click="toggleAlertMessageHappy()"
        ></section>

        <section
            v-if="alertMessageHappy.errors && alertMessageHappy.errors.length !== 0"
            class="section-alert-message-content-dashboard-happy"
        >
            <div
                class="div-alert-message-content-dashboard-happy"
                :class="`div-content-message-content-dashboard-happy-${alertMessageHappy.class}`"
            >
                <ButtonClose
                    :function="toggleAlertMessageHappy"
                    :hover-color="
                        alertMessageHappy.class === 'success'
                            ? 'success-happy'
                            : 'error-happy'
                    "
                />
            </div>
            <div
                class="div-alert-message-second-content-errors-dashboard-happy"
                :class="alertMessageHappy.class"
            >
                <h4 class="h4-alert-message-dashboard-happy">
                    {{ alertMessageHappy.title }}
                </h4>
                <p v-for="(error, i) in alertMessageHappy.errors" :key="i" class="bullet">
                    {{ error }}
                </p>
            </div>
        </section>
        <section class="section-alert-message-content-dashboard-happy" v-else>
            <div
                class="div-alert-message-content-dashboard-happy"
                :class="`div-content-message-content-dashboard-happy-${alertMessageHappy.class}`"
            >
                <ButtonClose
                    :function="toggleAlertMessageHappy"
                    :hover-color="
                        alertMessageHappy.class === 'success'
                            ? 'success-happy'
                            : 'error-happy'
                    "
                />
            </div>

            <div
                class="div-alert-message-second-content-dashboard-happy"
                :class="alertMessageHappy.class"
            >
                <h4 class="h4-alert-message-dashboard-happy">
                    {{ alertMessageHappy.title }}
                </h4>
                <p class="p-alert-message-dashboard-happy">
                    {{ alertMessageHappy.message }}
                </p>
            </div>
        </section>
    </section>
</template>

<style scoped>
.section-alert-message-dashboard-happy {
    @apply fixed top-0 left-0 w-full h-full z-40 flex justify-center;
}

.alert-message-dashboard-overlay-happy {
    @apply w-full h-full;
}
.section-alert-message-content-dashboard-happy {
    @apply z-50 absolute w-72 flex flex-col justify-center mt-52;
}
.div-alert-message-content-dashboard-happy {
    @apply w-full h-full rounded-t-md flex justify-end p-3 shadow shadow-text-dark-happy-light;
}
.div-content-message-content-dashboard-happy-success {
    @apply bg-green-light-happy;
}
.div-content-message-content-dashboard-happy-error {
    @apply bg-header-red-happy;
}

.div-alert-message-second-content-dashboard-happy {
    @apply w-full h-full rounded-b-md px-3 py-4 text-center shadow shadow-text-dark-happy-light;
}
.div-alert-message-second-content-errors-dashboard-happy {
    @apply w-full h-full rounded-b-md px-3 py-4 shadow shadow-text-dark-happy-light;
}

.success {
    @apply bg-green-happy text-text-dark-happy-light;
}
.error {
    @apply bg-border-red-happy-light  text-bg-happy-light;
}

.h4-alert-message-dashboard-happy {
    @apply text-lg font-semibold mb-2 text-center;
}

.p-alert-message-dashboard-happy {
    @apply text-base font-medium text-center;
}

.bullet {
    @apply relative pl-4;
}

.bullet::before {
    content: '•';
    position: absolute;
    left: 0;
}
</style>
